export default __webpack_public_path__ + "static/media/rUSD.93eb8a74.svg";